/**
 * Product-component bridge — see `product-bridge.tsx`. Kept as its own folder
 * because it is the one place in the marketing site that reaches into
 * `apps/app`, and that seam should be obvious in the tree.
 */
export * from "./product-bridge";
